import userProfileConstants from '../constants/user-profile-constants';

export const validate = values => {
  const errors = {};

  if (!values[userProfileConstants.fields.first_name]) {
    errors[userProfileConstants.fields.first_name] = 'COMMON.REQUIRED_FIELD';
  }

  if (!values[userProfileConstants.fields.last_name]) {
    errors[userProfileConstants.fields.last_name] = 'COMMON.REQUIRED_FIELD';
  }

  if (!values[userProfileConstants.fields.user_name]) {
    errors[userProfileConstants.fields.user_name] = 'COMMON.REQUIRED_FIELD';
  }

  if (!values[userProfileConstants.fields.email]) {
    errors[userProfileConstants.fields.email] = 'COMMON.REQUIRED_FIELD';
  }

  if (!values[userProfileConstants.fields.country]) {
    errors[userProfileConstants.fields.country] = 'COMMON.REQUIRED_FIELD';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/app/main/user-profile/validators/user-profile-form-validators.js